export default {
  "site.title": "YOYBUY AUTOS — Таблицы для умных покупок в Китае",
  "site.description": "Yoybuy Sheet — ваш инструмент для организации заказов из Китая. Сравнивайте цены, рассчитывайте доставку и экономьте с помощью умных таблиц.",
  "nav.home": "Главная",
  "nav.guide": "Руководство",
  "nav.categories": "Категории",
  "nav.contact": "Контакты",
  "hero.title": "Yoybuy Sheet — Ваш Умный Инструмент для Заказов из Китая",
  "hero.subtitle": "Организуйте покупки, сравнивайте цены и экономьте на доставке с помощью наших таблиц",
  "hero.cta_sheet": "Yoybuy Sheet",
  "hero.cta_buy": "Купить Сейчас",
  "categories.title": "Категории Товаров",
  "categories.subtitle": "Выберите интересующую вас категорию и начните покупки",
  "categories.all": "Все категории",
  "categories.choose": "Выбрать категорию...",
  "seo.title": "Что Такое Yoybuy Sheet и Почему Это Важно?",
  "seo.paragraph1": "Yoybuy Sheet представляет собой инновационный подход к организации покупок на китайских торговых платформах. Это специализированная система таблиц, которая позволяет пользователям систематизировать свои заказы, отслеживать статус доставки, сравнивать цены между различными продавцами и оптимизировать общие расходы на международную доставку.",
  "seo.paragraph2": "В современном мире онлайн-шопинга покупки на китайских платформах становятся всё более популярными среди покупателей по всему миру. Однако процесс заказа товаров из Китая может быть сложным и запутанным — множество продавцов, различные варианты доставки, необходимость отслеживания множества позиций одновременно. Именно здесь на помощь приходит Yoybuy Sheet.",
  "seo.paragraph3": "С помощью Yoybuy Sheet вы можете легко организовать все свои покупки в одном месте. Система позволяет вести учёт каждой позиции заказа, фиксировать цены в разных магазинах, рассчитывать примерную стоимость доставки и отслеживать статус каждого отправления. Это особенно полезно для тех, кто регулярно заказывает товары из Китая для личного пользования или небольшого бизнеса.",
  "seo.read_more": "Читать полное руководство",
  "article.title": "Полное Руководство по Yoybuy Sheet: Как Организовать Покупки из Китая",
  "article.back": "← Вернуться на главную",
  "footer.subscribe": "Подпишитесь на обновления",
  "footer.subscribe_text": "Получайте новые руководства и советы по покупкам из Китая",
  "footer.email_placeholder": "Ваш email",
  "footer.subscribe_btn": "Подписаться",
  "footer.quick_links": "Быстрые ссылки",
  "footer.contact_info": "Контактная информация",
  "footer.copyright": "© 2026 YOYBUY AUTOS. Все права защищены.",
  "footer.privacy": "Политика конфиденциальности",
  "footer.terms": "Условия использования",
  "footer.phone": "Телефон",
  "footer.email": "Email",
  "footer.address_label": "Адрес",
  "footer.address": "120 High Street, London, UK",
};